import React from 'react'
import cn from 'classnames'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import messages from '../translate'

function Breadcrumbs(props) {
  const { siteName, workflow, step, backClick, formatMessage } = props
  const workflowTitle = workflow.id ? ` / ${workflow.title}` : ''
  const stepsTitles = [
    formatMessage(messages.chooseWorkflow),
    formatMessage(messages.chooseObject),
    formatMessage(messages.assignTasks),
    formatMessage(messages.setSchedule),
  ]

  return (
    <Paper
      className={cn('mj-breadcrumb-paper', {
        'with-back-icon': step !== 0,
      })}>
      {step !== 0 && (
        <IconButton aria-label="back" size="small" onClick={backClick}>
          <ArrowBackIcon />
        </IconButton>
      )}
      <Typography variant="h6">
        {`${siteName}${workflowTitle}: ${stepsTitles[step]}`}
      </Typography>
    </Paper>
  )
}

export default Breadcrumbs
